import { createSlice } from "@reduxjs/toolkit";

const wizardContentSlice = createSlice({
  name: "wizardReducer",
  selectedInsurances: [],
  initialState: {
    stepIndex: 0,
    steps: [],
    availableInsurances: [],
    funds: {},
    portfolios: [],
    updatedFunds: [],
    changesInFunds: [],
    allAllocations: [],
    enableChangeFunds: false,
    applyToFuturePayments: true,
    updatedPortfolio: {},
    fundExchangePayload: [],
    isFundsParsed: false,
  },
  reducers: {
    setCurrentStep: (state, action) => {
      const { payload } = action;
      state.stepIndex = payload;
    },
    setWizardSteps: (state, action) => {
      const { payload } = action;
      state.steps = payload;
    },
    setSelectedInsurances: (state, action) => {
      const { payload } = action;
      state.selectedInsurances = payload;
    },
    setAvailableInsurances: (state, action) => {
      const { payload } = action;
      state.availableInsurances = payload;
    },
    setAllFunds: (state, action) => {
      const { payload } = action;
      state.funds = payload;
    },
    setPortfolios: (state, action) => {
      const { payload } = action;
      state.portfolios = payload;
    },
    setUpdatedFunds: (state, action) => {
      const { payload } = action;
      state.updatedFunds = payload;
    },
    setEnableChangeFunds: (state, action) => {
      const { payload } = action;
      state.enableChangeFunds = payload;
    },
    setChangesInFunds: (state, action) => {
      const { payload } = action;
      state.changesInFunds = payload;
    },
    setApplyToFuturePayments: (state, action) => {
      const { payload } = action;
      state.applyToFuturePayments = payload;
    },
    setUpdatedPortfolio: (state, action) => {
      const { payload } = action;
      state.updatedPortfolio = payload;
    },
    setFundExchangePayload: (state, action) => {
      const { payload } = action;
      state.fundExchangePayload = payload;
    },
    setFundsParsed: (state, action) => {
      const { payload } = action;
      state.isFundsParsed = payload;
    },
    setAllAllocations: (state, action) => {
      const { payload } = action;
      state.allAllocations = payload;
    },
    resetData: (state) => {
      state.updatedFunds = [];
      state.isFundsParsed = false;
      state.changesInFunds = [];
      state.enableChangeFunds = false;
      state.applyToFuturePayments = true;
      state.updatedPortfolio = {};
      state.fundExchangePayload = [];
    },
  },
});

export const {
  actions: {
    setCurrentStep,
    setWizardSteps,
    setSelectedInsurances,
    setAvailableInsurances,
    setAllFunds,
    setPortfolios,
    setUpdatedFunds,
    setEnableChangeFunds,
    setDisableChangeFunds,
    setChangesInFunds,
    setApplyToFuturePayments,
    setUpdatedPortfolio,
    setFundExchangePayload,
    resetData,
    setFundsParsed,
    setAllAllocations,
  },
  reducer: wizardContentReducer,
} = wizardContentSlice;
